import { Type } from 'class-transformer';

export class OwnerInfoHistoryResultDto {
  action: string;
  data: string;
  additionalInfo: string;
  @Type(() => Date)
  actionedOn: Date;
}
